import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class LocationModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (LocationModel._instance == null) LocationModel._instance = new LocationModel(authManager);
        return LocationModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'sites/locations', 'sites/locations/codelist');

        this.entityName = 'sites.Location';
        this.privileges = {
            create: [["adminSites"]],
            read: [["adminSites"],["manageSites"],["editSites"],["readSites"]],
            update: [["adminSites"]],
            delete: [["adminSites"]],
        };

        this.label = 'Location (Object)';
        this.setLabel = 'Locations (Objects)';

        this.browser = {
            name: 'default-sites-location-browser',
            moduleName: 'default-sites-location-browser',
            moduleTitle: 'Locations (Objects)',
            moduleStateSlotName: 'default-sites-location-browser',
        };

        this.editor = {
            name: 'default-sites-location-editor',
            moduleName: 'default-sites-location-editor',
            moduleTitle: 'Location (Object)',
            moduleStateSlotName: 'default-sites-location-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'color',
                type: 'string',
                persistent: true,
                label: 'Color',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'workingFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Working Folder',
            },
            {
                name: 'mapUrl',
                type: 'string',
                persistent: true,
                label: 'Map URL',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'mapFileId',
                type: 'File',
                persistent: true,
                label: 'Map File',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'locationTypeId',
                type: 'LocationType',
                persistent: true,
                label: 'Location Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'locationTypeLabel',
                type: 'string',
                persistent: false,
                label: 'Location Type',
                distinctLabel: 'Location Type (text)',
                readOnly: true,
                inBrowser: true,
            },
            {
                name: 'siteId',
                type: 'Site',
                persistent: true,
                label: 'Site',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'siteLabel',
                type: 'string',
                persistent: false,
                label: 'Site',
                readOnly: true,
                inBrowser: true,
            },
            {
                name: 'siteTimeZone',
                type: 'string',
                persistent: false,
                label: 'Site Time Zone',
                readOnly: true,
                filterable: true,
            },
            {
                name: 'siteTimeZoneLabel',
                type: 'string',
                persistent: false,
                label: 'Site Time Zone',
                distinctLabel: 'Site Time Zone (text)',
                readOnly: true,
            },
            {
                name: 'parentLocationId',
                type: 'Location',
                persistent: true,
                label: 'Parent Location (Object)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'constructionMethodId',
                type: 'ConstructionMethod',
                persistent: true,
                label: 'Construction method',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'startChainage',
                type: 'float',
                persistent: true,
                label: 'Start Chainage',
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'endChainage',
                type: 'float',
                persistent: true,
                label: 'End Chainage',
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'length',
                type: 'float',
                persistent: true,
                label: 'Length',
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'chainageDirection',
                type: 'int',
                persistent: true,
                label: 'Chainage Direction',
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'chainageBase',
                type: 'float',
                persistent: true,
                label: 'Chainage Base',
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
